module.exports = __webpack_public_path__ + "img/log-icon.54fce99d.svg";